import React from 'react';

// Honest top bar: no countdown, no fake scarcity – and NEVER a price here (regla de Tomás 2026-10-23).
const TOP_BAR_LONG = 'Engångsbetalning · 7 dagars nöjdhetsgaranti · Ladda ner direkt';
const TOP_BAR_SHORT = 'Engångsbetalning · 7 dagars garanti';
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="2re00ve76gyjv">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs font-medium sm:text-sm" data-id="element-57" data-mp="2meww7uv40ucf">
        <span className="hidden sm:inline" data-id="element-58" data-mp="2hdze1ia3o0ax">{TOP_BAR_LONG}</span>
        <span className="sm:hidden" data-id="element-59" data-mp="2cffshizf4qj3">{TOP_BAR_SHORT}</span>
      </div>
    </div>;
}